import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './components/HomePage.vue';
import MembersPage from './components/MembersPage.vue';
import AboutPage from './components/AboutPage.vue';
import LolPage from './components/LolPage.vue';
import CsPage from './components/CsPage.vue';
import CsBracketPage from './components/CsBracketPage.vue';
import OsPage from './components/OsPage.vue';
import AdminPage from './components/AdminPage.vue';

const routes = [
  { path: '/', component: HomePage },
  { path: '/members', component: MembersPage },
  { path: '/about', component: AboutPage },
  { path: '/cs', component: CsPage },
  { path: '/cs/bracket', component: CsBracketPage, meta: { hideNavbar: true } },
  { path: '/lol', component: LolPage },
  { path: '/os', component: OsPage },
  { path: '/admin', component: AdminPage }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;